import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { TrizService } from './services/triz-service';
import { TrizServiceImpl } from './services/impls/triz-service';
import { TrizApi } from './apis/triz-api';
import { TrizApiImpl } from './apis/impls/triz-api';

export const trizContainer = new ContainerModule(bind => {
    bind(TrizService).to(TrizServiceImpl);
    bind(TrizApi).to(TrizApiImpl);
});
